var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcDanger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.70812 23.0003C3.074 23.0003 2.45028 22.8383 1.89668 22.5295C0.106957 21.5312 -0.530706 19.2726 0.480589 17.4904L8.77306 2.87635C9.10727 2.28735 9.59727 1.80153 10.1891 1.47139C11.9689 0.478643 14.2225 1.10409 15.2281 2.87635L23.5206 17.4904C23.835 18.0446 24.0004 18.6705 24.0004 19.3075C24.0004 21.3508 22.3368 23.0003 20.2931 23.0003H3.70812Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.87052 20.7825C3.12611 20.9251 3.41442 21 3.70769 21H20.2926C21.2356 21 22 20.2421 22 19.3072C22 19.0164 21.9245 18.7306 21.7807 18.4772L13.4882 3.86309C13.0259 3.04827 11.9848 2.75935 11.163 3.21776C10.8905 3.36973 10.6654 3.59296 10.5121 3.86309L2.21963 18.4772C1.75728 19.292 2.04869 20.3241 2.87052 20.7825ZM13.2347 17.4792C13.2347 16.8235 12.6986 16.2919 12.0372 16.2919C11.3758 16.2919 10.8396 16.8235 10.8396 17.4792C10.8396 18.135 11.3758 18.6666 12.0372 18.6666C12.6986 18.6666 13.2347 18.135 13.2347 17.4792ZM13.1102 14.0825V7.74941H10.9546V14.0825H13.1102Z",
    fill: "#DE1B1B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDanger);
export default __webpack_public_path__ + "static/media/ic_danger.af971d57.svg";
export { ForwardRef as ReactComponent };